import { dispatchEvent } from "./events";

export function showConfirm(message) {
  return new Promise((resolve, reject) => {
    dispatchEvent('showConfirmModal', {
      message,
      onConfirm: () => resolve(true),
      onCancel: () => reject(false)
    });
  });
}

export function showAlert(message) {
  dispatchEvent('showAlertModal', {
    message
  });
}